import _ from '@/common/helpers';

const CUSTOM_FIELDS_RESOURCES = {
    customers: 'customers',
    paymentCards: 'payment-cards',
    plans: 'plans',
    products: 'products',
    subscriptions: 'subscriptions',
    transactions: 'transactions',
    websites: 'websites',
};

export default CUSTOM_FIELDS_RESOURCES;
export const CUSTOM_FIELDS_RESOURCES_LIST = Object.keys(CUSTOM_FIELDS_RESOURCES).map(key => ({
    label: _.unKebabCase(key),
    value: CUSTOM_FIELDS_RESOURCES[key],
}));
